<template>
  <base-dialog @cancel="cancelDialog" width="50%" :drag="false">
    <div class="oc-monitor-alert-header" slot="header">{{$t('dashboard.text_19')}}</div>
    <div class="oc-monitor-alert-body" slot="body">
      <div>
        <h2>{{ announcement?.title }}</h2>
      </div>
      <div>
        <span>{{ announcement?.content }}</span>
      </div>
    </div>
    <div slot="footer">
      <a-button @click="cancelDialog">{{$t('scope.text_457')}}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapState } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'AnnouncementNotifyDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      timer: null,
      modalProps: {
        dialogStyle: {
          position: 'fixed',
          right: '15px',
          bottom: '-404px',
          top: 'auto !important',
          transition: 'all .5s',
        },
      },
    }
  },
  computed: {
    ...mapState('auth', {
      loggedUsers: state => state.loggedUsers,
    }),
    announcement () {
      return this.params.announcement
    },
  },
  mounted () {
    this.timer = setTimeout(() => {
      this.modalProps.dialogStyle.bottom = '0'
    }, 500)
  },
  destroyed () {
    clearTimeout(this.timer)
  },
}
</script>

<style lang="scss">
.oc-monitor-alert-dialog.ant-modal {
  position: fixed;
  width: 300px !important;
  right: 0;
  bottom: 0;
  top: auto !important;
}
.oc-monitor-alert-header {
  color: #F00B0B;
}
.oc-monitor-alert-body {
  max-height: 200px;
  overflow: auto;
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    li {
      padding: 6px 0;
      border-bottom: 1px dashed #ccc;
    }
  }
}
</style>
